'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ = require('lodash');
var React = require('react');
var ReactDOM = require('react-dom');
var KEYS = require('../constants/keyCodes');

var preventNextMouseUp = function preventNextMouseUp(e) {
    e.preventDefault();
    e.target.removeEventListener('mouseup', preventNextMouseUp);
};

var createInputClass = function createInputClass(displayName, template, defaultPropOverride) {
    var Input = function (_React$Component) {
        _inherits(Input, _React$Component);

        function Input(props) {
            _classCallCheck(this, Input);

            var _this = _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));

            _this.timers = {};
            _this.handleChange = function (e) {
                var onChange = _this.props.onChange;

                if (_.isFunction(onChange)) {
                    var isValid = true;
                    onChange(e.target.value, isValid);
                }
            };
            _this.isDisabled = function () {
                return _this.props.disabled === true;
            };
            _this.getInputElement = function () {
                return ReactDOM.findDOMNode(_this.refs.input);
            };
            _this.focusFailed = false;
            _this.blurInput = function () {
                var element = _this.getInputElement();
                if (element) {
                    element.blur();
                }
            };
            _this.focusInput = function () {
                var select = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                var element = _this.getInputElement();
                if (element) {
                    element.focus();
                    if (select) {
                        _this.selectContent();
                    }
                    _this.focusFailed = element !== window.document.activeElement;
                }
            };
            _this.handleKeyDown = function (e) {
                var keyCode = e.keyCode;

                var isEsc = keyCode === KEYS.ESC;
                var isEscAndBlur = isEsc && _this.props.blurOnEscKey;
                var isEnter = keyCode === KEYS.ENTER;
                var isEnterAndBlur = isEnter && _this.props.blurOnEnterKey;

                if (isEscAndBlur || isEnterAndBlur) {
                    _this.isCanceled = isEscAndBlur;
                    _this.blurInput();
                }

                _this.props.onKeyDown(e, _this.blurInput);
            };
            _this.scrollInputToTopIfNeeded = function () {
                _this.getInputElement().scrollTop = 0;
            };
            _this.selectContent = function () {
                var inputElement = _this.getInputElement();
                if (!inputElement) {
                    return;
                }

                if (_.isFinite(_this.props.initialSelectionStart) && _.isFinite(_this.props.initialSelectionEnd)) {
                    inputElement.setSelectionRange(_this.props.initialSelectionStart, _this.props.initialSelectionEnd);
                } else {
                    inputElement.select();
                }
            };
            _this.onFocusCallback = _this.props.onFocus || _.noop;
            _this.onFocus = function (e) {
                e.target.addEventListener('mouseup', preventNextMouseUp); // Safari deselect on mouse up fix
                _this.isCanceled = false;
                _this.valueOnFocus = e.target.value;
                if (_this.props.selectOnFocus) {
                    _this.selectContent();
                }
                _this.onFocusCallback(e);
            };
            _this.onBlurCallback = _this.props.onBlur || _.noop;
            _this.onBlur = function (e) {
                _this.scrollInputToTopIfNeeded();
                _this.timers.reFocus = window.setTimeout(function () {
                    if (!window.document.hasFocus()) {
                        window.addEventListener('focus', _this.reFocus);
                    }
                }, 0);
                if (_this.isCanceled && _this.props.revertValueOnCancel) {
                    var isValid = true;
                    _this.props.onChange(_this.props.successValue || _this.valueOnFocus, isValid);
                }
                _this.onBlurCallback(e, _this.isCanceled);

                if (_this.props.preventBlur) {
                    _this.reFocus();
                }
            };
            _this.reFocus = function () {
                _this.focusInput();
                window.removeEventListener('focus', _this.reFocus);
            };
            _this.getInputClassName = function () {
                var additionalClass = _this.props.innerInputClass || '';
                return _this.props.getClassName(_this.props.defaultInputClass + ' ' + additionalClass);
            };
            _this.getInputProps = function () {
                return {
                    ref: 'input',
                    type: _this.props.type || 'text',
                    className: _this.getInputClassName(),
                    value: _this.props.value,
                    onChange: _this.handleChange,
                    disabled: _this.isDisabled(),
                    readOnly: _this.props.isReadOnly,
                    placeholder: _this.props.translateIfNeeded(_this.props.placeholder) || '',
                    maxLength: _this.props.maxLength,
                    spellCheck: false,
                    onKeyDown: _this.handleKeyDown,
                    onFocus: _this.onFocus,
                    onBlur: _this.onBlur,
                    dir: _this.props.dir,
                    name: _this.uniqueId,
                    id: _this.uniqueId
                };
            };
            return _this;
        }

        _createClass(Input, [{
            key: 'componentWillMount',
            value: function componentWillMount() {
                this.uniqueId = this.props.focusOnPrefixClick ? _.uniqueId('baseuilib-input-') : undefined;
            }
        }, {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!this.props.isReadOnly && this.props.autoSelect) {
                    this.timers.initialFocus = window.setTimeout(this.focusInput.bind(this, true), 0);
                } else if (this.props.focus) {
                    this.timers.initialFocus = window.setTimeout(this.focusInput.bind(this), 0);
                }
            }
        }, {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if (!this.props.isReadOnly && prevProps.isReadOnly) {
                    this.timers.writeableFocus = window.setTimeout(this.focusInput.bind(this, true), 0);
                }
            }
        }, {
            key: 'componentWillUpdate',
            value: function componentWillUpdate(nextProps) {
                if (nextProps.focus && (!this.props.focus || this.focusFailed)) {
                    window.clearTimeout(this.timers.blurUpdate);
                    this.timers.focusUpdate = window.setTimeout(this.focusInput.bind(this), 0);
                } else if (!nextProps.focus && this.props.focus) {
                    window.clearTimeout(this.timers.focusUpdate);
                    this.timers.blurUpdate = window.setTimeout(this.blurInput.bind(this), 0);
                }
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                _.forEach(this.timers, function (timer) {
                    return window.clearTimeout(timer);
                });
            }
        }, {
            key: 'render',
            value: function render() {
                return template.call(this);
            }
        }]);

        return Input;
    }(React.Component);

    Input.displayName = displayName;
    Input.propTypes = {
        value: React.PropTypes.string,
        onChange: React.PropTypes.func,
        disabled: React.PropTypes.bool,
        type: React.PropTypes.string,
        placeholder: React.PropTypes.string,
        defaultText: React.PropTypes.string,
        maxLength: React.PropTypes.number,
        prefix: React.PropTypes.string,
        blurOnEnterKey: React.PropTypes.bool,
        blurOnEscKey: React.PropTypes.bool,
        dir: React.PropTypes.string,
        defaultInputClass: React.PropTypes.string,
        innerInputClass: React.PropTypes.string,
        initialSelectionStart: React.PropTypes.number,
        initialSelectionEnd: React.PropTypes.number,
        onFocus: React.PropTypes.func,
        onBlur: React.PropTypes.func,
        onKeyDown: React.PropTypes.func,
        focus: React.PropTypes.bool,
        onClick: React.PropTypes.func,
        focusOnPrefixClick: React.PropTypes.bool,
        showInfoTooltip: React.PropTypes.bool,
        infoTooltipProps: React.PropTypes.object,
        isReadOnly: React.PropTypes.bool,
        autoSelect: React.PropTypes.bool,
        selectOnFocus: React.PropTypes.bool,
        revertValueOnCancel: React.PropTypes.bool,
        successValue: React.PropTypes.string,
        preventBlur: React.PropTypes.bool
    };
    Input.defaultProps = _.assign({}, {
        disabled: false,
        blurOnEnterKey: true,
        blurOnEscKey: true,
        placeholder: '',
        dir: 'ltr',
        onKeyDown: _.noop,
        focusOnPrefixClick: false,
        showInfoTooltip: false,
        infoTooltipProps: {},
        isReadOnly: false,
        autoSelect: false,
        selectOnFocus: true,
        revertValueOnCancel: true,
        defaultInputClass: 'input',
        preventBlur: false
    }, defaultPropOverride);

    return Input;
};
module.exports = createInputClass;


// WEBPACK FOOTER //
// ./~/wix-base-ui/lib/controls/inputClassFactory.js